import React from 'react';
import PhaseLoader, {phaseLoaderQuery} from './PhaseLoader';
import RoleLoader, {roleLoaderQuery} from './RoleLoader';
import {getPhaseName, getRoleName} from '../ProjectPortfolioReportUtils';
import {PHASE_BREAKDOWN_TYPE} from '../../../../constants';
import {LoadMore} from '../../../loaders/LoadMore';
import {Table} from '@/web-components';
import ProjectPortfolioPeriodRow from './ProjectPortfolioPeriodRow';

const PhaseRoleCascade = ({intl, projectId, deliverableId, startDate, endDate, useWinProbability, levelProps, withProject}) => {
	return (
		<LoadMore
			key="query-render-phase"
			query={phaseLoaderQuery}
			loader={<PhaseLoader />}
			variables={{
				projectId,
				deliverableId,
				startYear: startDate ? startDate.year() : undefined,
				startMonth: startDate ? startDate.month() + 1 : undefined,
				startDay: startDate ? startDate.date() : undefined,
				endYear: endDate ? endDate.year() : undefined,
				endMonth: endDate ? endDate.month() + 1 : undefined,
				endDay: endDate ? endDate.date() : undefined,
				ignoreBaselineWinChance: !useWinProbability,
				excludeOpportunityActuals: true,
			}}
		>
			{({data: phaseBreakdownData}) => {
				return (
					<Table.Rows data={phaseBreakdownData} {...levelProps} canExpand={true}>
						{({
							rowData: phaseRowData,
							tableColumnsProps: phaseTableColumnProps,
							expanded: phaseExpanded,
							nextLevelProps: roleLevelProps,
						}) => {
							return (
								<>
									<ProjectPortfolioPeriodRow
										financialNumbers={phaseRowData.financialNumbers}
										rowData={withProject(phaseRowData)}
										tableColumnProps={phaseTableColumnProps}
										headerColumn={getPhaseName(intl, phaseRowData)}
										canExpand={
											(phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.PHASE &&
												phaseRowData.phase.id) ||
											phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.NO_PHASE
										}
										useWinProbability={useWinProbability}
									/>
									{phaseExpanded && (
										<LoadMore
											key="query-render-role"
											query={roleLoaderQuery}
											loader={<RoleLoader />}
											variables={{
												projectId,
												deliverableId,
												phaseId:
													phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.PHASE &&
													phaseRowData.phase.id
														? phaseRowData.phase.id
														: phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.NO_PHASE
														? 0
														: null,
												startYear: startDate ? startDate.year() : undefined,
												startMonth: startDate ? startDate.month() + 1 : undefined,
												startDay: startDate ? startDate.date() : undefined,
												endYear: endDate ? endDate.year() : undefined,
												endMonth: endDate ? endDate.month() + 1 : undefined,
												endDay: endDate ? endDate.date() : undefined,
												ignoreBaselineWinChance: !useWinProbability,
												excludeOpportunityActuals: true,
											}}
										>
											{({data: roleBreakdownData}) => {
												return (
													<Table.Rows data={roleBreakdownData} {...roleLevelProps} canExpand={false}>
														{({rowData: roleRowData, tableColumnsProps: roleTableColumnProps}) => {
															return (
																<ProjectPortfolioPeriodRow
																	financialNumbers={roleRowData.financialNumbers}
																	rowData={withProject(roleRowData)}
																	tableColumnProps={roleTableColumnProps}
																	headerColumn={getRoleName(intl, roleRowData)}
																/>
															);
														}}
													</Table.Rows>
												);
											}}
										</LoadMore>
									)}
								</>
							);
						}}
					</Table.Rows>
				);
			}}
		</LoadMore>
	);
};

export default PhaseRoleCascade;
